<template>
    <div class="main_wrapper">
        <div class="av_logo" @click="onLogoClick">
            <img alt="logo" src="@/assets/icons/logo_mini.svg">
        </div>
        <div class="card_wrapper" v-if="loaded">
            <div v-if="itemData">
                <div>{{ itemData.time }}<br></div>
                <div v-if="!itemData.is_service_log">
                    <div v-if="!itemData.is_custom">{{ itemData.emoji }}</div>
                    {{ itemData.question }}
                </div>
                <div v-if="!itemData.is_service_log && itemData.show_answer">Response: {{ itemData.vote_type }}<br>
                </div>
                <div v-if="itemData.location">{{ translate('own_votesPlacement') }} {{ this.itemData.location }}<br></div>
                <div v-if="itemData.geolocation">Last known geolocation: <span v-html="getGeolocationString()"></span><br></div>
                <div v-if="itemData.user_geolocation">Current geolocation: <span
                    v-html="getUserGeolocationString()"></span><br></div>
                <div v-if="itemData.comment">{{ translate('own_votesComment') }} {{ itemData.comment }}<br></div>
                <div v-if="itemData.contact_info">{{translate('own_votesContactInfo')}} {{ itemData.contact_info }}<br></div>
                <div v-if="itemData.sec_level">{{ itemData.is_service_log ? 'Services' : 'Answer' }}:
                    {{ itemData.sec_level }}<br></div>
                <div>{{ itemData.is_service_log ? 'User\'s prior logs:' : translate('own_votesPriorVotes') }} {{ itemData.prior_votes }}</div>
                <div v-if="itemData.user">User: {{ itemData.user }}<br></div>
                <div v-if="itemData.audio">Audio: <a :href="itemData.audio" target="_blank">Listen</a><br></div>

                <div v-if="itemData.images && itemData.images.length > 0">
                    <br>
                    <table border="0">
                        <tbody>
                        <tr>
                            <td v-for="(item) in itemData.images"><a :href="item.image_url_origin" target="_blank"><img
                                class="vote_img"
                                :src="item.image_url_preview" height="100px"
                                alt="photo"/></a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="itemData.cro">
                    <br>Asset Information from CRO:<br>
                    <div v-if="itemData.cro.asset_number">Asset number: {{ itemData.cro.asset_number }}<br></div>
                    Deployed To: {{ itemData.cro.deployed_to }}<br>
                    <div v-if="itemData.cro.site_address">Site address: <span v-html="getCroSiteAddressString()"></span></div>
                    <div v-if="itemData.cro.asset_geolocation">Asset geolocation: <span v-html="getCroAssetGpsLinkString()"></span><br></div>
                    {{translate('own_votesContactInfo')}}<br>
                    <div style="margin-left: 24px;">
                        <span
                            v-if="itemData.cro.contact_info.name">   Name: {{
                                itemData.cro.contact_info.name
                            }}<br></span>
                        <span
                            v-if="itemData.cro.contact_info.email">   Email: {{
                                itemData.cro.contact_info.email
                            }}<br></span>
                        <span
                            v-if="itemData.cro.contact_info.phone">   Phone: {{
                                itemData.cro.contact_info.phone
                            }}<br></span>
                    </div>
                    <div v-if="itemData.cro.last_active">Last active on {{ itemData.cro.last_active }}<br></div>
                </div>

                <div v-if="itemData.servicecore">
                    <br>Asset Information:<br>
                    - Name: {{ this.itemData.servicecore.product_name }}<br>
                    - Serial: {{ this.itemData.servicecore.serial_number }}<br>
                    - Location: <span v-html="getServiceCoreGoogleMapText()"></span><br>
                    - Rental: <span v-html="getSCRental()"></span><br>
                    - Site: {{ getCustomerSiteAddress() }}<br>
                    <span
                        v-if="this.itemData.servicecore.customer_name">- Customer: <span
                        v-html="getSCCustomerData()"></span><br></span>
                    - {{ this.itemData.servicecore.rental_link ? 'Delivery' : 'Pick-up' }} job: <span v-html="getSCRentalJob()"></span><br>
                    <div v-if="itemData.servicecore.last_job">
                        <br>Last completed job:<br>
                        - {{ itemData.servicecore.last_job.type_name }} <a :href="this.itemData.servicecore.last_job.link" target="_blank">{{this.itemData.servicecore.last_job.doc_number}}</a> on {{this.itemData.servicecore.last_job.completed_at}} by {{this.itemData.servicecore.last_job.driver_name}}<br>
                        <div v-if="itemData.servicecore.last_job.driver_notes">- Driver notes: {{ itemData.servicecore.last_job.driver_notes }}<br></div>
                        <div v-if="itemData.servicecore.last_job.notes">- Notes: {{ itemData.servicecore.last_job.notes }}<br></div>
                        <div v-if="itemData.servicecore.last_job.attachments && itemData.servicecore.last_job.attachments.length > 0">
                            - Job photos:
                            <br>
                            <table border="0">
                                <tbody>
                                <tr>
                                    <td v-for="(item) in itemData.servicecore.last_job.attachments"><a :href="item" target="_blank"><img
                                        class="vote_img"
                                        :src="item" height="70px"
                                        alt="photo"/></a></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div v-if="itemData.last_service_log">
                    <div style="width:50px;height:1px;background:#000000 1px;margin-top:16px;margin-bottom:16px;"></div>
                    Last service log:<br>
                    - Date: {{ this.itemData.last_service_log.time }}<br>
                    <span
                        v-if="this.itemData.last_service_log.services">- Services: {{
                            this.itemData.last_service_log.services
                        }}<br></span>
                    <span
                        v-if="this.itemData.last_service_log.placement">- Placement: {{
                            this.itemData.last_service_log.placement
                        }}<br></span>
                    <span
                        v-if="this.itemData.last_service_log.comment">- Comment: {{
                            this.itemData.last_service_log.comment
                        }}<br></span>
                    <span
                        v-if="this.itemData.last_service_log.user">- Serviced by: {{
                            this.itemData.last_service_log.user
                        }}<br></span>
                    <span v-if="this.itemData.last_service_log.audio">- Audio: <a
                        :href="this.itemData.last_service_log.audio" target="_blank">Listen</a><br></span>

                    <div v-if="itemData.last_service_log.images &&  itemData.last_service_log.images.length > 0">
                        <table border="0">
                            <tbody>
                            <tr>
                                <td v-for="(item) in itemData.images"><a :href="item.image_url_origin"
                                                                         target="_blank"><img class="vote_img"
                                                                                              :src="item.image_url_preview"
                                                                                              height="100px"
                                                                                              alt="photo"/></a></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <a :href="itemData.last_service_log.view_logs_link" target="_blank">View all logs</a>
                </div>
            </div>
            <div v-if="showErrorLimited" class="error_block">
                You've reached your free monthly votes limit. To get full access please contact AirVote team: <a
                href="mailto:team@air-vote.com" target="_blank">team@air-vote.com</a>
            </div>
            <div v-if="showErrorNotFound" class="error_block">
                Requested rate not found. Please contact AirVote team: <a
                href="mailto:team@air-vote.com" target="_blank">team@air-vote.com</a>
            </div>
        </div>
        <div class="dashboard_link" @click="onVisitDashboardClick" v-if="loaded">
            Visit dashboard
        </div>
    </div>


</template>

<script>

import errorMixin from '@/mixins/errorMixin';
import customModalDialog from '@/components/widgets/customModalDialog';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

export default {
    name: 'rateDetailsPublic',

    mixins: [mixin, errorMixin],

    components: {
        customModalDialog,
    },

    data() {
        return {
            showErrorLimited: false,
            showErrorNotFound: false,
            loaded: false,
            isLimited: false,
            itemData: null,

        }
    },

    computed: {
        ...mapGetters({
            isUserAdmin: 'auth/isUserAdmin',
        }),
        ...mapState({
            accessToken: state => state.auth.accessToken,
            userInfo: state => state.auth.userInfo
        }),

    },

    watch: {},

    async mounted() {
        console.log("kek sdfasdf1")
        this.loadData()
    },

    methods: {
        ...mapActions({
            getPublicRateInfo: 'rate/getPublicRateInfo',
            getManagerReportAction: 'owner/getManagerReport',
        }),

        ...mapMutations({
            setLanguage: 'setLanguage',
            setProgressBarTag: 'setProgressBarTag',
        }),

        async loadData() {
            console.log("kek sdfasdf")
            this.setProgressBarTag({
                show: true,
                tag: 'load_vote_details'
            })
            try {
                const response = await this.getPublicRateInfo(this.$route.params.uid)
                if (response.data.success) {
                    this.itemData = response.data.rate
                    // this.itemData = JSON.parse(`
                    // {
                    //             "is_limited": false,
                    //             "is_service_log": false,
                    //             "time": "06/02/2022 13:02",
                    //             "vote_type": "so-so",
                    //             "emoji": "\ud83ddfe8",
                    //             "is_custom": false,
                    //             "show_answer": false,
                    //             "question": "How clean is this restroom?",
                    //             "location": "J Bar – Portables | 0001859",
                    //             "geolocation": "",
                    //             "user_geolocation": "https://www.google.com/maps/place/40.666666666667,-80.337304795384/@40.666666666667,-80.337304795384,17z",
                    //             "set_geolocation": "https://my.air-vote.com/questions/5dec5a32-8139-4322-8105-e5a0e972e2c7/manage?set_location=40.666666666667,-80.337304795384",
                    //             "comment": "Home Depot. 1001. Pumped and ran power from roof. Both AC units set at max and did not trip breakers.",
                    //              "sec_level": "No TP, Full, Smells, Dirty",
                    //             "prior_votes": 1,
                    //             "user": "",
                    //             "contact_info": "",
                    //             "images": [
                    //                 {
                    //                     "id": 606,
                    //                     "guid": "cc328c10-5a0a-4cb0-994a-0bc444725b62",
                    //                     "rate_id": 34852,
                    //                     "image_url": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/1200/full.jpg",
                    //                     "image_url_origin": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/origin.jpg",
                    //                     "image_url_preview": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/200/preview.jpg"
                    //                 },
                    //                 {
                    //                     "id": 606,
                    //                     "guid": "cc328c10-5a0a-4cb0-994a-0bc444725b62",
                    //                     "rate_id": 34852,
                    //                     "image_url": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/1200/full.jpg",
                    //                     "image_url_origin": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/origin.jpg",
                    //                     "image_url_preview": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/200/preview.jpg"
                    //                 },
                    //                 {
                    //                     "id": 606,
                    //                     "guid": "cc328c10-5a0a-4cb0-994a-0bc444725b62",
                    //                     "rate_id": 34852,
                    //                     "image_url": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/1200/full.jpg",
                    //                     "image_url_origin": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/origin.jpg",
                    //                     "image_url_preview": "https://airvote-attachments.s3.us-east-2.amazonaws.com/photos/812421e7-9053-4e71-bd6b-962963d78fa7/200/preview.jpg"
                    //                 }
                    //             ],
                    //             "audio": null,
                    //             "cro": {
                    //                 "asset_number": "dsfsadf",
                    //                 "deployed_to": "building kek",
                    //                 "type": "sdafsf",
                    //                 "address": "address address address",
                    //                 "delivered": "10.10.22 10:11:11",
                    //                 "delivered_days": 4,
                    //                 "last_active": "10.10.22 10:11:11",
                    //                 "last_active_days": 34,
                    //                 "status": "status",
                    //                 "contact_info": {
                    //                     "name": "NAME",
                    //                     "phone": "phone",
                    //                     "email": "email"
                    //                 },
                    //                 "holding_yard": "yard",
                    //                 "last_customer": "last customer",
                    //                 "status_type": "deployed"
                    //             },
                    //             "servicecore": {
                    //                 "item_id": "404946",
                    //                 "serial_number": "STD-0018",
                    //                 "barcode": "STD-0018",
                    //                 "product_name": "Standard Portable Unit",
                    //                 "rental_number": "R15",
                    //                 "rental_start_date": "2022-02-28 00:00:00.000000",
                    //                 "rental_end_date": null,
                    //                 "customer_name": null,
                    //                 "customer_phone": null,
                    //                 "customer_emails": null,
                    //                 "customer_site_name": "Chimney Oaks Club",
                    //                 "customer_site_type": null,
                    //                 "customer_site_address_1": "491 Scales Creek Rd",
                    //                 "customer_site_address_city": "Homer",
                    //                 "customer_site_address_state": "GA",
                    //                 "customer_site_zip_code": "30547",
                    //                 "customer_site_county": null,
                    //                 "customer_site_territory": null,
                    //                 "customer_site_latitude": "34.3526941",
                    //                 "customer_site_longitude": "-83.4892952",
                    //                 "item_latitude": "34.3546141",
                    //                 "item_longitude": "-83.488143",
                    //                 "jobid_link": "https://app.servicecore.com/jobs/id/190612682",
                    //                 "rental_link": "https://app.servicecore.com/rentals/id/440100",
                    //                 "item_location_link": "https://www.google.com/maps/place/34.3546141,-83.488143/@34.3546141,-83.488143,17z"
                    //             },
                    //             "last_service_log": {
                    //                 "is_limited": false,
                    //                 "is_service_log": false,
                    //                 "time": "06/02/2022 13:02",
                    //                 "vote_type": "so-so",
                    //                 "emoji": "\ud83ddfe8",
                    //                 "is_custom": false,
                    //                 "show_answer": false,
                    //                 "question": "How clean is this restroom?",
                    //                 "location": "J Bar – Portables | 0001859",
                    //                 "geolocation": "",
                    //                 "user_geolocation": "https://www.google.com/maps/place/40.666666666667,-80.337304795384/@40.666666666667,-80.337304795384,17z",
                    //                 "set_geolocation": "https://my.air-vote.com/questions/5dec5a32-8139-4322-8105-e5a0e972e2c7/manage?set_location=40.666666666667,-80.337304795384",
                    //                 "comment": "Home Depot. 1001. Pumped and ran power from roof. Both AC units set at max and did not trip breakers.",
                    //                  "sec_level": "No TP, Full, Smells, Dirty",
                    //                 "prior_votes": 1,
                    //                 "user": "",
                    //                 "contact_info": "",
                    //                 "images": [],
                    //                 "audio": null,
                    //                 "cro": null,
                    //                 "servicecore": null,
                    //                 "view_logs_link": "https://google.com"
                    //             }
                    //         }`)
                }
            } catch (error) {
                console.log("kek error", error)
                if(error.data.error.code == 1157) {
                    this.showErrorLimited = true
                    this.updateErrorUrl('limited')
                } else if(error.data.error.code == 1104 || error.data.error.code == 1158) {
                    this.showErrorNotFound = true
                    this.updateErrorUrl('not_found')
                }
                //todo handle error??
            } finally {
                this.loaded = true
                this.setProgressBarTag({
                    show: false,
                    tag: 'load_vote_details'
                })
            }
        },
        updateErrorUrl(type) {
            history.replaceState(
                {},
                null,
                location.origin + '/votedetails/' + this.$route.params.uid + `?e=${type}`
            )
        },

        getGeolocationString() {
            if (this.itemData.geolocation == '[disabled]') {
                return "[disabled]"
            } else {
                let date = ''
                if (this.itemData.geolocation_date) {
                    date = ` (as of ${this.itemData.geolocation_date})`
                }
                return `<a href=\"${this.itemData.geolocation}\" target="_blank">View</a> ${date}`
            }
        },
        getUserGeolocationString() {
            if (this.itemData.user_geolocation == 'disabled') {
                return "[disabled]"
            } else {
                return `<a href="${this.itemData.user_geolocation}" target="_blank">View</a>`
            }
        },
        getCroSiteAddressString() {
            if(this.itemData.cro.site_geolocation) {
                return `<a href="${this.itemData.cro.site_geolocation}" target="_blank">${this.itemData.cro.site_address}</a><br>`
            } else {
                return `${this.itemData.cro.site_address}<br>`
            }
        },
        getCroAssetGpsLinkString() {
            return `<a href="${this.itemData.cro.asset_geolocation}" target="_blank">View</a>`
        },
        getServiceCoreGoogleMapText() {
            if (this.itemData.servicecore.item_location_link) {
                return `<a href="${this.itemData.servicecore.item_location_link}" target="_blank">View on Google Maps</a>`
            } else {
                return "N/A"
            }
        },
        getCustomerSiteAddress() {
            if (this.itemData.servicecore.customer_site_address_1) {
                return this.itemData.servicecore.customer_site_address_1 + ', ' + this.itemData.servicecore.customer_site_address_city + ', ' + this.itemData.servicecore.customer_site_address_state
            } else {
                return "N/A"
            }
        },
        getSCRental() {
            if (this.itemData.servicecore.rental_link) {
                return `<a href="${this.itemData.servicecore.rental_link}" target="_blank">${this.itemData.servicecore.rental_link}</a>`
            } else {
                return "none"
            }
        },
        getSCRentalJob() {
            if (this.itemData.servicecore.jobid_link) {
                return `<a href="${this.itemData.servicecore.jobid_link}" target="_blank">${this.itemData.servicecore.jobid_link}</a>`
            } else {
                return "N/A"
            }
        },
        getSCCustomerData() {
            let value = `<a href="${this.itemData.servicecore.customer_link}" target="_blank">${this.itemData.servicecore.customer_name}</a>`
            if (this.itemData.servicecore.customer_phone) {
                value += ', ' + this.itemData.servicecore.customer_phone
            }
            return value
        },
        onVisitDashboardClick() {
            this.$router.push({name: 'OwnerPlaceManagement'})
        },
        onLogoClick() {
            window.open('https://air-vote.com/', '_blank')
        },

    },


}
</script>

<style>

.main_wrapper .md-accent svg {
    stroke: #438348;
}

.main_wrapper a {
    color: #326eea;
    text-decoration: underline;
    cursor: pointer;
}
</style>
<style scoped>
.main_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.av_logo {
    margin-top: 50px;
    margin-bottom: 35px;
    cursor: pointer;
}

.dashboard_link {
    margin-top: 24px;
    color: #326eea;
    text-decoration: underline;
    cursor: pointer;
    padding: 8px;
}
.error_block {
    padding: 16px;
}

.card_wrapper {
    display: flex;
    flex-direction: column;
    align-items: start;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);
    min-height: 50px;
    max-width: 80%;
    min-width: 400px;
    word-break: break-word;
    padding: 24px;
}

.vote_img {
    width: 100px;
}

@media screen and (max-width: 600px) {
    .main_wrapper {
        padding: 0px;
    }

    .card_wrapper {
        min-width: 200px;
        max-width: 100%;
        width: 90%;
        /*box-shadow: 0 0;*/
    }

    .dashboard_link {
        margin-top: 16px;
    }

}


</style>

